export default {"src":"/_next/static/media/menu.29d1a5b0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};